<template>
	<div class="page page-profile">
		<div class="lines-wrapper">
			<div class="lines-circle"></div>
		</div>
		<ul class="weeks-list" v-if="!Helpers.isTouch()">
			<li class="weeks-item" v-for="item in weeks"
				:class="{active: item.id <= currentWeek, current: item.id === currentWeek}">
				<div class="item-content">
					<div class="item-wrapper" v-if="(item.id <= currentWeek) && (getWeekData(item.id))">
						<div class="week-group">
							<div class="cup-icon">
								<svg-cup></svg-cup>
							</div>
							<h3 class="text">{{ item.name }}</h3>
						</div>
						<div class="line"></div>
						<div class="item-info">
							<div class="item-info__place">{{ getWeekData(item.id).position }} место</div>
							<div class="item-info__bottom-group">
								<div class="item-info__time-group">
									{{ toHHMMSS(getWeekData(item.id).time) }}
									<div class="item-info__time-group-icon">
										<svg-clock></svg-clock>
									</div>
								</div>
								<div class="item-info__divider"></div>
								<div class="item-info__favorites-group">
									{{ getWeekData(item.id).score }}
									<div class="item-info__favorites-group-icon">
										<svg-star></svg-star>
									</div>
								</div>
							</div>

							<div class="item-info__video-replay" v-if="getWeekData(item.id).link">
								<a target="_blank" :href="getWeekData(item.id).link">+ видеоповтор</a>
							</div>
						</div>

					</div>
					<div class="item-wrapper" v-else>
						<div class="week-group">
							<h3 class="text">{{ item.name }}</h3>
						</div>
						<div class="line"></div>
					</div>
				</div>
			</li>
		</ul>
		<swiper class="weeks-list slider" :options="this.swiperOptions" v-else>
			<div class="swiper-button-prev" slot="button-prev"><arrow></arrow></div>
			<div class="swiper-button-next" slot="button-next"><arrow></arrow></div>
			<swiper-slide class="weeks-item" v-for="item in weeks" :key="item.id"
						  :class="{active: item.id <= currentWeek, current: item.id === currentWeek}">
				<div class="item-content-wrapper">
					<div class="item-content">
						<div class="item-wrapper" v-if="(item.id <= currentWeek) && (getWeekData(item.id))">
							<div class="week-group">
								<div class="cup-icon">
									<svg-cup></svg-cup>
								</div>
								<h3 class="text">{{ item.name }}</h3>
							</div>
							<div class="line"></div>
							<div class="item-info">
								<div class="item-info__place">{{ getWeekData(item.id).position }} место</div>
								<div class="item-info__bottom-group">
									<div class="item-info__time-group">
										{{ toHHMMSS(getWeekData(item.id).time) }}
										<div class="item-info__time-group-icon">
											<svg-clock></svg-clock>
										</div>
									</div>
									<div class="item-info__divider"></div>
									<div class="item-info__favorites-group">
										{{ getWeekData(item.id).score }}
										<div class="item-info__favorites-group-icon">
											<svg-star></svg-star>
										</div>
									</div>
								</div>
								<div class="item-info__video-replay" v-if="getWeekData(item.id).link">
									<a target="_blank" :href="getWeekData(item.id).link">+ видеоповтор</a>
								</div>
							</div>
						</div>
						<div class="item-wrapper" v-else>
							<div class="week-group">
								<h3 class="text">{{ item.name }}</h3>
							</div>
							<div class="line"></div>
						</div>
					</div>
				</div>
			</swiper-slide>
		</swiper>
		<div class="page-content">
			<div class="user-block">
				<div class="title-wrapper">
					<div class="user-avatar"
						 :style="`background-image: url(${ user.image_link ? user.image_link : noAvatar})`"></div>
					<h1 class="title user-name">{{user.first_name }} {{user.last_name}}</h1>
				</div>
				<div class="text-wrapper">
					<p class="text" v-if="!userRating.length">
						Пройди тест и загрузи <a href="#" @click.prevent="getVideoPopup">видеоповтор</a>, чтобы попасть в общий рейтинг
						<router-link to="/test/start">пройди тест</router-link>
					</p>
					<p class="text" v-else>
						Спасибо! Результат сохранен, можно улучшить свою позицию в рейтинге, загрузив <a href="#" @click.prevent="getVideoPopup">видеоповтор</a>.
					</p>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {TweenMax} from 'gsap';
	import Helpers from '@/tools/Helpers';
	import Swiper from "../../../node_modules/vue-awesome-swiper/src/swiper.vue";
	import SwiperSlide from "../../../node_modules/vue-awesome-swiper/src/slide.vue";
	import star from '@/assets/svg/star.svg';
	import clock from '@/assets/svg/clock.svg';
	import cup from '@/assets/svg/cup.svg';
    import arrow from '@/assets/svg/slider-arrow.svg';

	const weeks = [
		{
			name: 'первая неделя',
			id: 1,
		},
		{
			name: 'вторая неделя',
			id: 2,
		},
		{
			name: 'третья неделя',
			id: 3,
		},
		{
			name: 'четвертая неделя',
			id: 4,
		},
		{
			name: 'пятая неделя',
			id: 5,
		}
	];
	export default {
		components: {
			SwiperSlide,
			Swiper,
			'svg-star': star,
			'svg-clock': clock,
			'svg-cup': cup,
            arrow
		},
		name: 'Profile',
		data() {
			return {
				videoInfo: {
					link: '',
					date: new Date()
				},
				Helpers,
				weeks,
				testDone: true,
				hasVideo: false,
				noAvatar: '/static/img/profile/no-ava.png',
				swiperOptions: {
                    autoplay: false,
                    prevButton: '.swiper-button-prev',
                    nextButton: '.swiper-button-next'
				}
			}
		},
		mounted() {
			this.$store.commit('UPD_UI_SHOW', true);
			this.$store.commit('SET_POPUP', {name: false});
			this.userRating[0].link &&
			this.userRating[0].week == this.currentWeek ?
				this.hasVideo = true : this.hasVideo = false;
		},
		computed: {
			currentWeek() {
				return this.$store.getters['getCurrentWeek'];
			},
			user() {
				return this.$store.getters['getUserData'];
			},
			userRating() {
				return this.$store.getters['getUserRatingList'];
			},

		},
		methods: {
			sendVideo() {

				if (!/^(f|ht)tps?:\/\//i.test(this.videoInfo.link)) {
					this.videoInfo.link = "http://" + this.videoInfo.link;
				}

				this.$store.dispatch('postVideo', this.videoInfo).then(() => {
					this.$store.commit('SET_POPUP', {name: 'Thank'});
					this.hasVideo = true;
				});

				Helpers.ga().send('submit', 'Отправить видео', this.videoInfo.link);
			},
			getVideoPopup() {
				this.$store.commit('SET_POPUP', {name: 'Info'});
			},
			getWeekData(id) {
				if (this.userRating.length) {
					return this.userRating.filter(item => {
						return parseInt(item.week) === parseInt(id);
					})[0];
				} else {
					return false;
				}

			},
			toHHMMSS(secs) {
				let sec_num = parseInt(secs, 10);
				let hours = Math.floor(sec_num / 3600) % 24;
				let minutes = Math.floor(sec_num / 60) % 60;
				let seconds = sec_num % 60;
				return ([hours, minutes, seconds]
					.map(v => v < 10 ? "0" + v : v)
					.filter((v, i) => v !== "00" || i > 0)
					.join(":"));
			}
		},
		created() {
		}
	}
</script>



// WEBPACK FOOTER //
// Profile.vue?e18e6350